import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

/**
 * Returns whether the current business entity holds any S-Corp bundle entitlement
 * and the corresponding banking price string to display in the UI.
 *
 * `entitlements` from `useBusinessEntity` is always an Entitlements (Map) instance
 * — never null — so `.has()` is safe to call without optional chaining.
 *
 * @returns {{ hasSCorpBundle: boolean, bankingPrice: string }}
 */
export default function useSCorpBankingPrice() {
  const { entitlements } = useBusinessEntity();

  const hasSCorpBundle =
    entitlements.has('s_corp_basic_bundle_v1') ||
    entitlements.has('s_corp_essential_bundle_v1') ||
    entitlements.has('s_corp_premium_bundle_v1');

  return {
    hasSCorpBundle,
    bankingPrice: hasSCorpBundle ? '$0/month' : '$5/month'
  };
}
